/**
 * @bos/portal3 — the page header, the design system's recurring signature.
 *
 * A tracked-caps eyebrow (with a short pine tick), a serif title, an optional lede, and
 * an optional actions slot on the right. Every authenticated page opens with one, so the
 * product reads as a single, deliberate whole rather than a set of bare forms.
 */
import type { ReactNode } from 'react';

export function PageHeader({
  eyebrow,
  title,
  titleAccessory,
  lede,
  actions,
}: {
  eyebrow: string;
  title: ReactNode;
  /** Rendered inline after the title (e.g. a status badge). */
  titleAccessory?: ReactNode;
  lede?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <p className="eyebrow">{eyebrow}</p>
      <div className="page-header__bar">
        <h1 className="page-header__title">
          {title}
          {titleAccessory ? <> {titleAccessory}</> : null}
        </h1>
        {actions ? <div className="page-header__actions">{actions}</div> : null}
      </div>
      {lede ? <p className="page-header__lede">{lede}</p> : null}
    </header>
  );
}
